module.exports = __webpack_public_path__ + "static/media/EVIGarten_en.3944f9ca.png";